import AddIcon from '@mui/icons-material/Add';
import { Box, ButtonBase, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import WarehouseProductCard from "../../../../../components/global/cards/products/warehouse/WarehouseProductCard";
import { PRODUCT_FILTER_KEYS } from '../../../../../components/global/DataGrid/Filter';
import MpAddProduct from '../../../../../components/global/ModalsProgression/MpAddProduct/MpAddProduct';
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import ShCopyButton from '../../../../../components/theme/ShCopy';
import ShLabel from '../../../../../components/theme/label/ShLabel';
import SidepanelLoader from '../../../../../components/theme/sidepanel2/SidepanelLoader';
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../../components/theme/text/Text";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { useExportProductsMutation, useGetProductsQuery } from "../../../../../newapi/warehouse/productSlice";
import { ReactComponent as Shirt } from '../../../../../styles/svg/shirt.svg';
import { tokens } from "../../../../../theme";
import { UserPrivileges } from '../../../../../utils/permissions';
import { general_states } from '../../../../../utils/staticEnums';

import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import  UploadOutlinedIcon  from '@mui/icons-material/UploadOutlined';
import MImportData from '../../../../../components/global/Modals/MImportData';
import MDynamicValues from '../../../../../components/global/Modals/MDynamicValues';
import SHQuickAction from '../../../../../components/theme/Modal/SHQuickAction';
import { useGetRelationsSelectQuery } from '../../../../../newapi/global/relation/relationSlice';
import { ImportStandAloneFileLogo, productColumns } from '../../../../../utils/importColumnDefinitions';
import { showToastPromise } from '../../../../../utils/toasts';
const SpStockDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpStockDetails/SPStockDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const colors = tokens(theme.palette.mode);

    return (
        <ButtonGroup version={2}>
            <Shbutton
                onClick={props.handleExportOpen}
                className={"group-btn"}
                color={"primaryGrey"}
                variant="contained"
                endIcon={<DownloadOutlinedIcon/>}
            >
                {t('export')}
            </Shbutton>
            {props.hasImportPermission && (
                <Shbutton
                    className={"group-btn"}
                    color={theme.palette.mode === "dark" ? "grey" : "grey"} 
                    onClick={() => {
                        props.importOrdersOpen();
                    }}
                    endIcon={<UploadOutlinedIcon/>}
                    variant="contained"
                >
                    {t('import')}
                </Shbutton>
            )}
            {props.hasCreatePermission && (
                <Shbutton 
                    className={"group-btn"} 
                    color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                    onClick={() => props.handleOpen(true)}
                    endIcon={<AddIcon/>}
                    variant="contained"
                >
                    {t("new_product")}
                </Shbutton>
            )}
        </ButtonGroup>
    );
}


const ProductOverview = (props) => {
    const { t,i18n } = useTranslation();

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [config, setConfig] = useState({
        isVirtual: false,
        withoutDaW:false,
        withStock:false,
    });
    
    const [isExtended, setIsExtended] = useState(false);
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
    const [spStockLoading, setSpStockLoading] = useState();

    const hasImportPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.IMPORT_MANAGE])
    );
    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.PRODUCT_MANAGE])
    );

    let gridOptions = {
        export:true,
        disableCustomActionsOnPhone: true,
        isSidepanel: true,
        filter: [
                ...(isFulfilment ? [PRODUCT_FILTER_KEYS.RELATION] : []),
                PRODUCT_FILTER_KEYS.STATE,
                PRODUCT_FILTER_KEYS.PRODUCTDIMENSIONS,
                PRODUCT_FILTER_KEYS.STOCK,
                PRODUCT_FILTER_KEYS.QUARANTINE,
                PRODUCT_FILTER_KEYS.SAFETY_STOCK,
                PRODUCT_FILTER_KEYS.BACKORDER_WITH_INBOUND,
                PRODUCT_FILTER_KEYS.BACKORDER_WITHOUT_INBOUND,
                PRODUCT_FILTER_KEYS.ADDON,
                PRODUCT_FILTER_KEYS.SERIALNUMBER
            ],
    };

    const [importOrdersModalOpen,setImportOrdersModalOpen] = useState(false);
    const importOrdersModal = {
        open: importOrdersModalOpen,
        setOpen: setImportOrdersModalOpen,
    }

    const importOrdersOpen = () => {
        setImportOrdersModalOpen(true);
    }

    const importOrdersClose = () => {
        setImportOrdersModalOpen(false);
    }

    const [productExportModalOpen, setProductExportModalOpen] = useState(false);
    const productExportModal = {
        open: productExportModalOpen,
        setOpen: setProductExportModalOpen
    }

    const { data: relationData } = useGetRelationsSelectQuery();

    const [exportProducts, {isLoading: isExporting}] = useExportProductsMutation();
    const exportProductsCall = async (values) => {
        const exportPromise = exportProducts({
            isVirtual: false,
            relationId: values?.relationId,
        }).unwrap();

        showToastPromise(
            exportPromise,
            t,
            {
                pending: t('export_processing') || 'Processing export...',
                success: t('export_success') || 'Export completed successfully',
                error: t('export_failed') || 'Export failed'
            }
        ).then((result) => {
            // Check if it's a background processing response
            if (result.processing) {
                console.log('Export is being processed in background. Export ID:', result.exportId);
            }
        }).catch((error) => {
            console.error("Export failed", error);
        });
    }

    // Only fulfilment customers pick a relation; non-fulfilment customers export all their products directly
    const handleExportOpen = () => isFulfilment ? productExportModal.setOpen(true) : exportProductsCall();

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions importOrdersOpen={importOrdersOpen} handleOpen={handleOpen} handleExportOpen={handleExportOpen} hasCreatePermission={hasCreatePermission} hasImportPermission={hasImportPermission}></GridActions>,
        });

        return () => {
            
        }
    },[]);

    const handleOpen = () => {
        setAddModalOpen(true);
    }

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
    };

    const [productId, setProductId] = useState();
    const productIdRef = useRef(productId);
    
    const getProductDetails = (params) => {
        if (!params) return;
    
        const newProductId = parseInt(params.row.id);
        // Only update state if the productId has actually changed
        if (productIdRef.current !== newProductId) {
            if(!spStockLoading){
                setSpStockLoading(true);
            }
            setProductId(newProductId);
            productIdRef.current = newProductId; // Update the ref to the new value
        }
        
            setIsExtended(true);
    };
    

    const columns = [
        {
            field: "sku",
            headerName: t("sku"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton palette={theme.palette.mode === "dark" ? "pastel" : "normal"} variant={theme.palette.mode === "dark" ? "blue" : "primary"} />
                }
                return (
                    // <Box>
                    //     <Text clickable semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.sku}</Text>
                    // </Box>

                    <Box sx={{
                        width:1,
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Text clickable semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.sku}</Text>
                        <ShCopyButton className={"copyel"} closeAfter={1500} value={params.row.sku}></ShCopyButton>
                    </Box>
                );
            }
        },
        {
            field: "description",
            headerName: t("description"),
            flex:2,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                if(params.row.description?.length > 30) {
                    return (
                        <SHQuickAction
                            component={
                                <Box
                                    sx={{
                                        p:1,
                                    }}
                                >
                                    <Text>
                                        {params.row.description}
                                    </Text>
                                </Box>
                            }
                            disableAutoFocus
                            disableEnforceFocus
                            disableScrollLock
                        >
                            {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                <Box
                                    aria-owns={anchorEl ? 'simple-popover' : undefined}
                                    aria-haspopup="true"
                                    onMouseEnter={onMouseEnter}
                                    onMouseLeave={onMouseLeave}
                                    onTouchStart={onTouchStart}
                                    sx={{
                                        width:1,
                                        height:1,
                                        display:"flex",
                                        alignItems:'center'
                                    }}
                                >
                                    <Text noBreak>{params.row.description}</Text>
                                </Box>
                            )}
                        </SHQuickAction>
                    )
                } 
                return (
                    <Text noBreak>{params.row.description}</Text>
                )
            },
        },
        {
            field: "barcode",
            headerName: t("barcode"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if(params.row.barcode?.length > 10) {
                    return (
                        <SHQuickAction
                            component={
                                <Box
                                    sx={{
                                        p:1,
                                    }}
                                >
                                    <Text>
                                        {params.row.barcode}
                                    </Text>
                                </Box>
                            }
                            disableAutoFocus
                            disableEnforceFocus
                            disableScrollLock
                        >
                            {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                <Box
                                    aria-owns={anchorEl ? 'simple-popover' : undefined}
                                    aria-haspopup="true"
                                    onMouseEnter={onMouseEnter}
                                    onMouseLeave={onMouseLeave}
                                    onTouchStart={onTouchStart}
                                    sx={{
                                        width:1,
                                        height:"100%",
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:'space-between',
                                        ".copyel": {
                                            opacity:0,
                                        },
                                        "&:hover .copyel": {
                                            opacity:1,
                                        }
                                    }}
                                >
                                    <Text clickable >{params.row.barcode}</Text>
                                    <ShCopyButton color={colors.txt["primary"]} className={"copyel"} closeAfter={1500} value={params.row.barcode}></ShCopyButton>
                                </Box>
                            )}
                        </SHQuickAction>
                    )
                } 
                return (
                    <Box 
                        sx={{
                            width:1,
                            height:"100%",
                            display:"flex",
                            alignItems:"center",
                            justifyContent:'space-between',
                            ".copyel": {
                                opacity:0,
                            },
                            "&:hover .copyel": {
                                opacity:1,
                            }
                        }}
                    >
                        <Text clickable >{params.row.barcode}</Text>
                        <ShCopyButton color={colors.txt["primary"]} className={"copyel"} closeAfter={1500} value={params.row.barcode}></ShCopyButton>
                    </Box>
                );
                // return params.row.barcode
            },
        },
        ...isFulfilment ? [{
            field: "relation",
            headerName: t("relation"),
            flex:1,
            filter: PRODUCT_FILTER_KEYS.RELATION,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (params.row.relation ? params.row.relation.name : t('unknown'));
            },
        }] : [],
        {
            field: "safetyStock",
            headerName: t("safety_stock"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if (params.row.safetyStock && (!params.row.stock?.total_available || params.row.safetyStock > params.row.stock.total_available)) {
                    return (
                        <Text bold color={colors.red[400]}>
                            {params.row.safetyStock}
                        </Text>
                    );
                } else {
                    return params.row.safetyStock
                }
            },
        },
        {
            field: "stock_quantity",
            headerName: t("stock_quantity"),
            flex:1,
            filter: PRODUCT_FILTER_KEYS.STOCK,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (params.row.stock && params.row.stock.total_quantity ? params.row.stock.total_quantity : 0);
            },
        },
        {
            field: "stock_available",
            headerName: t("stock_available"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (params.row.stock && params.row.stock.total_available ? params.row.stock.total_available : 0);
            },
        },
        {
            field: "stock_quarantine",
            headerName: t("stock_quarantine"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (params.row.stock && params.row.stock.total_quarantine && params.row.stock.total_quarantine > 0 ? params.row.stock.total_quarantine : "");
            },
        },
        {field: "createdAt", headerName: t("created_at") , flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            let date = new Date(cellValues.row.createdAt).toLocaleDateString(i18n.language);

            if(cellValues.row.state === general_states.DELETED) {
                return (
                    <SHQuickAction
                        component={
                            <Box sx={{ p: 1 }}>
                                <Text>{t('created_at')}: {date}</Text>
                            </Box>
                        }
                        disableAutoFocus
                        disableEnforceFocus
                        disableScrollLock
                    >
                        {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                            <Box
                                aria-owns={anchorEl ? 'simple-popover' : undefined}
                                aria-haspopup="true"
                                onMouseEnter={onMouseEnter}
                                onMouseLeave={onMouseLeave}
                                onTouchStart={onTouchStart}
                                sx={{ display: "flex", alignItems: "center", height: 1 }}
                            >
                                <ShLabel size={24} fitted palette="normal" variant="red">
                                    {t('deleted')}
                                </ShLabel>
                            </Box>
                        )}
                    </SHQuickAction>
                )
            }

            return (
                <Text>{date}</Text>
            )
        }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (cellValues) => {
                // console.log(cellValues.row);
                return (
                    <WarehouseProductCard onClick={() => getProductDetails(cellValues)} skeleton={cellValues.row.skeleton ?? false} {...cellValues.row}/>
                    // <Box
                    //     sx={{
                    //         background:`${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100]}`,
                    //         paddingX:2,
                    //         paddingY:1.5,
                    //         borderRadius:2
                    //     }}
                    // >

                    // </Box>
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            <ShDataGrid2 key={theme.palette.mode + config.withoutDaW + config.withStock}
                content={useGetProductsQuery}
                config={config}
                gridActions={<GridActions importOrdersOpen={importOrdersOpen} handleOpen={handleOpen} handleExportOpen={handleExportOpen} hasCreatePermission={hasCreatePermission} hasImportPermission={hasImportPermission}></GridActions>}
                onRowClick={getProductDetails}
                title={t('overview')} 
                gridOptions={gridOptions} 
                sortModel={{field: columns[0].field,type:"ASC"}}
                columns={columns}>
            </ShDataGrid2>
            {spStockLoading && 
                <SpStockDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    productId={productId}
                />
            }
            
            <MImportData
                onOpen={() => importOrdersModal.setOpen(true)} 
                onClose={() => importOrdersModal.setOpen(false)} 
                open={importOrdersModal.open} 
                handleClose={importOrdersClose} 

                logo={<ImportStandAloneFileLogo Icon={Shirt} />}
                title={t("products")}
                fileType={"producten"}
                columns={productColumns}
                exampleFile={"/Voorbeeld_import_producten.xlsx"}
                importSettings={[
                    {
                        name: "weighttype",
                        label: t("weight_type"),
                        type: "list",
                        defaultValue: "g",
                        options: [
                            { id: "g", name: "g" },
                            { id: "kg", name: "kg" }
                        ]
                    },
                    {
                        name: "dimensionstype",
                        label: t("dimensions_type"),
                        type: "list",
                        defaultValue: "mm",
                        options: [
                            { id: "mm", name: "mm" },
                            { id: "cm", name: "cm" }
                        ]
                    },
                    {
                        name: "onlyupdate",
                        label: t("only_update"),
                        type: "boolean",
                        defaultValue: false
                    },
                    {
                        name: "updatebarcodes",
                        label: t("update_barcodes"),
                        type: "boolean",
                        defaultValue: false
                    },
                    {
                        name: "setinactive",
                        label: t("set_products_inactive"),
                        type: "boolean",
                        defaultValue: false
                    }
                ]}
            />

            <MpAddProduct onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose} />

            <MDynamicValues
                open={productExportModal.open}
                handleClose={() => productExportModal.setOpen(false)}
                title={t("export_products")}
                labelWidth={280}
                fields={[
                    { name: "relationId", label: t("relation"), type: "list", search: true, required: true, options: relationData ?? [] },
                ]}
                onConfirm={(values) => exportProductsCall(values)}
            />
        </Box>
    );
}
export default ProductOverview;